
export const helloWorldFn = () => {
  console.log("Hello world! ✨");
  console.log("Edit the ./src/app.ts file to get started");
};
